import React from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native-web';

import Image from '../../../shared/Image';
import Button from '../../../ui/Button';
import BodyText from '../../../ui/BodyText';
import { HeaderText } from '../../../ui/HeaderText';

import './Slide.module.scss';

import umbrella from '../../../../../images/icons/umbrella.svg';
import expresspay from '../../../../../images/icons/expresspay.svg';
import moneycycle from '../../../../../images/icons/moneycycle.svg';

export default function SaveMoney({ showPaymentsButton }) {
  return (
    <View styleName="slide">
      <HeaderText styleName="slide__header" level="1">Save Money</HeaderText>
      <View>
        <Image source={umbrella} styleName="slide__icon slide__icon--umbrella" />
        <BodyText styleName="slide__copy">
          Our no-show/late cancellation feature saved professionals nearly
          $2 Million dollars last year!
        </BodyText>
      </View>
      <View>
        <Image source={expresspay} styleName="slide__icon" />
        <BodyText styleName="slide__copy">
          Get your money instantly for only 50 cents compared to other platforms that
          charge 1% or more. (Don’t be square, that’s an average $450/year savings!)
        </BodyText>
      </View>
      <View>
        <Image source={moneycycle} styleName="slide__icon slide__icon--moneycycle" />
        <BodyText styleName="slide__copy">
          One low transaction fee. No added fees, no matter what card you charge.
        </BodyText>
      </View>
      { showPaymentsButton && (
        <Button
          size="medium"
          text="Get Started"
          link="provider.settings_menu.payments"
          linkParams={{ clickSource: 'growth_tab_swiper' }}
        />
      )}
    </View>
  );
}

SaveMoney.propTypes = {
  /** boolean to show the payments setup button */
  showPaymentsButton: PropTypes.bool,
};

SaveMoney.defaultProps = {
  showPaymentsButton: false,
};
